import { VidyoConnector } from "@/features/vidyo-call/types/vidyoclient-nativewebrtc-sdk";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import {
  getEntityId,
  getParticipantId,
  isRoomSystem,
} from "../utils/participants-utils";

export async function createParticipantsLifecycle(
  vidyoConnector: VidyoConnector,
) {
  const addParticipant = useVidyoStore.getState().participants.add;
  const removeParticipant = useVidyoStore.getState().participants.remove;

  await Promise.all([
    vidyoConnector.RegisterParticipantEventListener({
      onJoined: (participant) => {
        addParticipant({
          participantId: getParticipantId(participant.userId),
          entityId: getEntityId(participant.userId),
          name: participant.name,
          isAudioEnabled: true,
          isVideoEnabled: true,
          isHandRaised: false,
          isRoomSystem: isRoomSystem(participant.userId),
        });
      },
      onLeft: (participant) => {
        removeParticipant(getParticipantId(participant.userId));
      },
      onDynamicChanged: (participants) => {
        const existingParticipants =
          useVidyoStore.getState().participants.participants;
        const newParticipants = participants.filter(
          (p) =>
            !existingParticipants.some(
              (ep) => ep.participantId === getParticipantId(p.userId),
            ),
        );
        newParticipants.forEach((p) => {
          addParticipant({
            participantId: getParticipantId(p.userId),
            entityId: getEntityId(p.userId),
            name: p.name,
            isAudioEnabled: true,
            isVideoEnabled: true,
            isCurrentUser: p.isLocal,
            isHandRaised: false,
            isRoomSystem: isRoomSystem(p.userId),
          });
        });
      },
      onLoudestChanged: () => {
        // the loadest participant
      },
    }),
  ]);
}
